"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = void 0;
var _classVarianceAuthority = require("class-variance-authority");
var _react = require("react");
var _helpers = require("../../common/helpers");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["variant", "height", "width", "className", "role", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var classes = (0, _classVarianceAuthority.cva)(['animate-pulse', 'bg-gray-100', 'block'], {
  variants: {
    variant: {
      // \00a0 unicode no-break space
      // Origin and scale effects make skeleton the size of text within the given line height
      text: ['rounded', 'h-auto', "before:empty:content-['\\00a0']", 'origin-[0px_55%]', 'scale-y-[0.6]', 'my-0'],
      rounded: ['rounded'],
      circular: ['rounded-full'],
      rectangular: []
    },
    hasChildren: {
      "true": ['[&>*]:hidden'],
      "false": []
    },
    hasHeight: {
      "true": [],
      "false": []
    },
    hasWidth: {
      "true": [],
      "false": []
    }
  },
  compoundVariants: [{
    hasChildren: true,
    hasHeight: false,
    className: ['h-auto']
  }, {
    hasChildren: true,
    hasWidth: false,
    className: ['max-w-fit']
  }]
});

/**
 * Skeleton - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/feedback-skeleton)
 */
var Skeleton = exports.Skeleton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'text' : _ref$variant,
    height = _ref.height,
    width = _ref.width,
    className = _ref.className,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'status' : _ref$role,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    props = _objectWithoutProperties(_ref, _excluded);
  var hasChildren = !!props.children;
  var hasWidth = !!width;
  var hasHeight = !!height;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    role: role,
    className: (0, _helpers.cn)(classes({
      variant: variant,
      className: className,
      hasChildren: hasChildren,
      hasHeight: hasHeight,
      hasWidth: hasWidth
    }), className),
    style: _objectSpread({
      height: height,
      width: width
    }, style)
  }));
});